module.exports = __webpack_public_path__ + "4a1054ee0b7721ad616d36c7423c8d73.svg";